import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ReactComponent as NoDataCardIcon } from '../../../images/icons/no_data_card_icon.svg';
import { darkPurple, dimGrey } from '../../../mainTheme';

const NoDataCard = () => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box sx={{ mb: '24px', mt: '24px' }}>
        <NoDataCardIcon />
      </Box>
      <Typography
        gutterBottom
        sx={{
          color: darkPurple,
          fontSize: '18px',
          fontWeight: 500,
          lineHeight: '24px',
          letterSpacing: '0.2px',
        }}
      >
        No Data Available
      </Typography>
      <Typography
        sx={{
          color: dimGrey,
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: '20px',
          letterSpacing: '0.2px',
        }}
        mb={2}
      >
        There is no data available for this selection at the moment.
      </Typography>
    </Box>
  );
};

export default NoDataCard;
